<template>
  <!-- <a href="asdadsd" target="_blank" cl>Jakis Link</a> -->
  <v-scroll-x-transition>
  <v-btn
    
    v-if="url"
    color="primary"
    class="custom-link ml-6"
    outlined
    :href="`${url}`"
    >Learn more on Creative Gallery</v-btn
  >
</v-scroll-x-transition>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "CategoryLink",
  computed: {
    ...mapState(["category"]),
    ...mapGetters(["topCategories"]),
    url() {
      if (this.category.activeCategories.length == 1) {
        //     //  this.category.activeCategories
        //     // console.log(this.category.activeCategories[0]);
        const selectedCat = this.topCategories
          .map((tc) => tc.categories)
          .flat()
          .find((subCat) => subCat._id == this.category.activeCategories[0]);
        return selectedCat.url;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.custom-link {
  position: absolute;
  left: 0;
  top: -5em;
}
</style>
